// English Sounds Data based on your phonetic charts
export const soundsData = [
  // VOWELS
  {
    id: 'e-bee',
    symbol: 'ē',
    example: 'bee',
    image: 'https://images.unsplash.com/photo-1568526381923-caf3fd520382?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'i-itch',
    symbol: 'ĭ',
    example: 'itch',
    image: 'https://plus.unsplash.com/premium_photo-1723780940284-eeab067adc98?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'a-cake',
    symbol: 'ā',
    example: 'cake',
    image: 'https://images.unsplash.com/photo-1578985545062-69928b1d9587?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'e-bed',
    symbol: 'ĕ',
    example: 'bed',
    image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'a-apple',
    symbol: 'ă',
    example: 'apple',
    image: 'https://images.unsplash.com/photo-1560806887-1e4cd0b6cbd6?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'i-bike',
    symbol: 'ī',
    example: 'bike',
    image: 'https://images.unsplash.com/photo-1485965120184-e220f721d03e?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'o-octopus',
    symbol: 'ŏ',
    example: 'octopus',
    image: 'https://plus.unsplash.com/premium_photo-1723733104322-827186b5eb9e?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'u-up',
    symbol: 'ŭ',
    example: 'up',
    image: 'https://images.unsplash.com/photo-1514923995763-768e52f5af87?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'aw-claw',
    symbol: 'aw',
    example: 'claw',
    image: 'https://images.unsplash.com/photo-1712980502482-9dd8f7e0cc63?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'o-boat',
    symbol: 'ō',
    example: 'boat',
    image: 'https://plus.unsplash.com/premium_photo-1675802755792-a7cfd346b5be?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'oo-book',
    symbol: 'oo',
    example: 'book',
    image: 'https://images.unsplash.com/photo-1543002588-bfa74002ed7e?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'u-glue',
    symbol: 'ū',
    example: 'glue',
    image: 'https://images.unsplash.com/photo-1536786724684-63545518d243?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'yu-cube',
    symbol: 'yū',
    example: 'cube',
    image: 'https://images.unsplash.com/photo-1567646303972-f7de3a9c0a05?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'oy-boy',
    symbol: 'oy',
    example: 'boy',
    image: 'https://images.unsplash.com/photo-1504494701988-c068aedece14?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'ow-cow',
    symbol: 'ow',
    example: 'cow',
    image: 'https://images.unsplash.com/photo-1618080206739-14e8ac105472?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'er-her',
    symbol: 'er',
    example: 'her',
    image: 'https://plus.unsplash.com/premium_photo-1664366737698-3a98169201c3?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'ar-car',
    symbol: 'ar',
    example: 'car',
    image: 'https://images.unsplash.com/photo-1542362567-b07e54358753?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'or-corn',
    symbol: 'or',
    example: 'corn',
    image: 'https://images.unsplash.com/photo-1578652903016-b78571b87410?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },
  {
    id: 'schwa-banana',
    symbol: 'ə',
    example: 'banana',
    image: 'https://images.unsplash.com/photo-1571771894821-ce9b6c11b08e?w=300&h=300&fit=crop',
    category: 'vowels',
    subcategory: 'vowels'
  },

  // CONSONANTS - Stops
  {
    id: 'p-pig',
    symbol: 'p',
    example: 'pig',
    image: 'https://images.unsplash.com/photo-1580682777666-24a7b3024e24?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'stops'
  },
  {
    id: 'b-ball',
    symbol: 'b',
    example: 'ball',
    image: 'https://images.unsplash.com/photo-1498747946579-bde604cb8f44?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'stops'
  },
  {
    id: 't-turtle',
    symbol: 't',
    example: 'turtle',
    image: 'https://images.unsplash.com/photo-1437622368342-7a3d73a34c8f?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'stops'
  },
  {
    id: 'd-dog',
    symbol: 'd',
    example: 'dog',
    image: 'https://images.unsplash.com/photo-1552053831-71594a27632d?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'stops'
  },
  {
    id: 'k-kite',
    symbol: 'k',
    example: 'kite',
    image: 'https://images.unsplash.com/photo-1604153741124-8e0eb40964ab?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'stops'
  },
  {
    id: 'g-goat',
    symbol: 'g',
    example: 'goat',
    image: 'https://images.unsplash.com/photo-1524024973431-2ad916746881?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'stops'
  },

  // CONSONANTS - Liquids
  {
    id: 'l-leaf',
    symbol: 'l',
    example: 'leaf',
    image: 'https://images.unsplash.com/photo-1525498128493-380d1990a112?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'liquids'
  },
  {
    id: 'r-rabbit',
    symbol: 'r',
    example: 'rabbit',
    image: 'https://images.unsplash.com/photo-1629898569904-669319348211?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'liquids'
  },

  // CONSONANTS - Nasals
  {
    id: 'm-monkey',
    symbol: 'm',
    example: 'monkey',
    image: 'https://images.unsplash.com/photo-1540573133985-87b6da6d54a9?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'nasals'
  },
  {
    id: 'n-nose',
    symbol: 'n',
    example: 'nose',
    image: 'https://images.unsplash.com/photo-1466921583968-f07aa80c526e?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'nasals'
  },
  {
    id: 'ng-king',
    symbol: 'ng',
    example: 'king',
    image: 'https://images.unsplash.com/photo-1457052271742-6b6b66887aeb?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'nasals'
  },

  // CONSONANTS - Affricates
  {
    id: 'ch-chair',
    symbol: 'ch',
    example: 'chair',
    image: 'https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'affricates'
  },
  {
    id: 'j-jellyfish',
    symbol: 'j',
    example: 'jellyfish',
    image: 'https://images.unsplash.com/photo-1508311603478-ce574376c3cf?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'affricates'
  },

  // CONSONANTS - Glides
  {
    id: 'wh-whale',
    symbol: 'wh',
    example: 'whale',
    image: 'https://images.unsplash.com/photo-1568430462989-44163eb1752f?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'glides'
  },
  {
    id: 'w-watermelon',
    symbol: 'w',
    example: 'watermelon',
    image: 'https://images.unsplash.com/photo-1708982553355-794739c6693e?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'glides'
  },
  {
    id: 'y-yoyo',
    symbol: 'y',
    example: 'yoyo',
    image: 'https://images.unsplash.com/photo-1646954843635-126c0fe8f3d7?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'glides'
  },

  // CONSONANTS - Fricatives
  {
    id: 'f-fish',
    symbol: 'f',
    example: 'fish',
    image: 'https://images.unsplash.com/photo-1578507065211-1c4e99a5fd24?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'v-volcano',
    symbol: 'v',
    example: 'volcano',
    image: 'https://images.unsplash.com/photo-1580250642511-1660fe42ad58?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'th-thumb',
    symbol: 'th',
    example: 'thumb',
    image: 'https://images.unsplash.com/photo-1596230529625-7ee10f7b09b6?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'th-father',
    symbol: 'th',
    example: 'father',
    image: 'https://images.unsplash.com/photo-1557176278-3326a3193580?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 's-sun',
    symbol: 's',
    example: 'sun',
    image: 'https://images.unsplash.com/photo-1614642264762-d0a3b8bf3700?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'z-zebra',
    symbol: 'z',
    example: 'zebra',
    image: 'https://images.unsplash.com/photo-1526319238109-524eecb9b913?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'sh-sheep',
    symbol: 'sh',
    example: 'sheep',
    image: 'https://images.unsplash.com/photo-1554755209-85e44182e019?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'zh-treasure',
    symbol: 'zh',
    example: 'treasure',
    image: 'https://images.unsplash.com/photo-1642211841112-2beeda7bfc07?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  },
  {
    id: 'h-hat',
    symbol: 'h',
    example: 'hat',
    image: 'https://plus.unsplash.com/premium_photo-1693221161784-e6a735e8e4b4?w=300&h=300&fit=crop',
    category: 'consonants',
    subcategory: 'fricatives'
  }
];

export const soundCategories = [
  { id: 'all', name: 'All Sounds', count: soundsData.length },
  { id: 'vowels', name: 'Vowels', count: soundsData.filter(s => s.category === 'vowels').length },
  { id: 'consonants', name: 'Consonants', count: soundsData.filter(s => s.category === 'consonants').length },
  { id: 'stops', name: 'Stops', count: soundsData.filter(s => s.subcategory === 'stops').length },
  { id: 'liquids', name: 'Liquids', count: soundsData.filter(s => s.subcategory === 'liquids').length },
  { id: 'nasals', name: 'Nasals', count: soundsData.filter(s => s.subcategory === 'nasals').length },
  { id: 'affricates', name: 'Affricates', count: soundsData.filter(s => s.subcategory === 'affricates').length },
  { id: 'glides', name: 'Glides', count: soundsData.filter(s => s.subcategory === 'glides').length },
  { id: 'fricatives', name: 'Fricatives', count: soundsData.filter(s => s.subcategory === 'fricatives').length }
];